import { useEffect } from "react";
import { triggerPreviewDwell } from "../lib/telemetry/triggerPreview.js";

/**
 * Times a trigger's what-if preview while it is on screen (`ui.trigger_preview`,
 * lib/telemetry/triggerPreview.js). Pass the shown preview's ids, or a null `triggerId` while
 * none is shown; a hover ends when they change or the caller unmounts.
 * @param {{forecastId: string|null, triggerId: string|null, from: "timeline"}} deps
 */
export function useTriggerPreviewDwell({ forecastId, triggerId, from }) {
  useEffect(() => {
    if (!triggerId) return undefined;
    const preview = { forecastId, triggerId, from };
    triggerPreviewDwell.show(preview);
    return () => triggerPreviewDwell.hide(preview);
  }, [forecastId, triggerId, from]);
}
